import { t } from '@lingui/macro'
import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { useMainHeaderOrgQuery } from '../../mainheader/MainHeader'

export const HeadTitle: FC<{
  title: string | null | undefined
}> = (props) => {
  const organisation = useMainHeaderOrgQuery()
  return (
    <Helmet titleTemplate={`${organisation?.name ?? 'Looop'} - %s`}>
      {props.title && <title>{props.title}</title>}
      <meta name="description" content={t`We love learning`} />
    </Helmet>
  )
}

export default HeadTitle
